<template>
  <modal :show="visible" modalClasses="modal-xl">
    <template #header></template>
    <h3 class="text-center">
      {{ info.id ? "Cập nhật quy cách" : "Thêm mới quy cách" }}
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row>
            <b-col cols="4">
              <ValidationProvider
                name="Tên quy cách"
                rules="required"
                vid="name"
                v-slot="{ errors }"
              >
                <base-input
                  label="Tên quy cách"
                  type="number"
                  :error="errors[0]"
                  v-model="info.name"
                  :valid="errors.length == 0"
                ></base-input>
              </ValidationProvider>
            </b-col>
            <b-col cols="4">
              <ValidationProvider
                name="Màu sắc"
                rules="required"
                v-slot="{ errors }"
              >
                <color
                  style="max-width:100%"
                  v-model="info.color"
                  label="Màu sắc"
                  :error="errors[0]"
                ></color>
              </ValidationProvider>
            </b-col>
            <b-col cols="4">
              <ValidationProvider
                name="Màu sắc"
                rules="required"
                v-slot="{ errors }"
              >
                <base-select
                  v-model="info.unit"
                  :options="['M', 'Yard', 'Kg', 'Sợi']"
                  label="Đơn vị tính"
                  :error="errors[0]"
                ></base-select>
              </ValidationProvider>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <base-input
                :label="
                  `${info.unit ? info.unit : 'ĐVT'}/${
                    info.unit == 'Sợi' ? 'Bó' : 'Cuộn'
                  }`
                "
                type="number"
                v-model="info.unitHank"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                :label="`${info.unit == 'Sợi' ? 'Bó' : 'Cuộn'}/bịch`"
                type="number"
                v-model="info.hankBag"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                :label="`${info.unit ? info.unit : 'ĐVT'}/Bịch`"
                type="number"
                v-model="info.unitBag"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                label="Bịch/bao"
                type="number"
                v-model="info.bagSack"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                :label="`${info.unit ? info.unit : 'ĐVT'}/Bao`"
                type="number"
                v-model="info.unitSack"
              ></base-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <base-input
                :label="`${info.unit == 'Sợi' ? 'Bó' : 'Cuộn'}/bao`"
                type="number"
                v-model="info.hankSack"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                label="Định mức"
                type="number"
                v-model="info.quota"
              ></base-input>
            </b-col>
            <b-col>
              <base-input label="Co giãn" v-model="info.elastic"></base-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <base-input
                label="Mật độ"
                type="text"
                v-model="info.densities"
              ></base-input>
            </b-col>
            <b-col>
              <base-input
                label="Co giãn trước"
                type="text"
                v-model="info.pre_elastic"
              ></base-input>
            </b-col>
            <b-col>
              <base-input label="Chỉ số lược" v-model="info.comb_index"></base-input>
            </b-col>
          </b-row>
        </form>
      </ValidationObserver>
      <button type="button" @click="handleClose" class="btn btn-secondary">
        Đóng (Esc)
      </button>
      <button type="button" @click="doSave(1)" class="btn btn-success">
        Lưu tiếp (Shift + F4)
      </button>
      <button type="button" @click="doSave(0)" class="btn btn-dark">
        Lưu đóng (F4)
      </button>
    </block>
    <event
      @doCancel="handleClose"
      @doSave="doSave(0)"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>

<script>
import { productService } from "@/_services";
export default {
  data() {
    return {
      visible: false,
      info: {
        color: {
          id: 1
        },
        hankBag: 0,
        unitHank: 0,
        unitBag: 0,
        unitSack: 0,
        bagSack: 0
      },
      infoOwn: {},
      product: {}
    };
  },
  methods: {
    doSave(type) {
      if (!this.visible) return;
      var self = this;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        self.$refs.bmdal.block();
        if (self.info.id) {
          productService
            .updateSpec(self.info.id, self.product.id, self.info)
            .then(res => {
              self.$alertify.success(res.message);
              self.infoOwn.name = res.data.name;
              self.infoOwn.hankBag = res.data.hankBag;
              self.infoOwn.hankSack = res.data.hankSack;
              self.infoOwn.bagSack = res.data.bagSack;
              self.infoOwn.unitHank = res.data.unitHank;
              self.infoOwn.unitBag = res.data.unitBag;
              self.infoOwn.unitSack = res.data.unitSack;
              self.infoOwn.unit = res.data.unit;
              self.infoOwn.quota = res.data.quota;
              self.infoOwn.color = res.data.color;
              if (type == 0) {
                self.visible = false;
              }
              this.$emit("save", self.infoOwn);
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              self.$refs.bmdal.unBlock();
            });
        } else {
          productService
            .createSpec(self.product.id, self.info)
            .then(res => {
              self.$alertify.success("Thêm thành công");
              self.info = {};
              self.$emit("submit:success",res.data );
              self.product.productSpecifys.unshift(res.data);
              if (type == 0) {
                self.visible = false;
              }
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              self.$refs.bmdal.unBlock();
            });
        }
      });
    },
    handleClose() {
      this.info = {};
      this.visible = false;
    },
    setData(product, Specify) {
      this.product = product;
      if (Specify) {
        this.info = Object.assign({}, Specify);
        this.infoOwn = Specify;
        if (!Specify.color || !Specify.color.id) {
          this.info.color = {
            id: 1
          };
        }
      }
    }
  },
  watch: {
    "info.unitHank": function() {
      console.log("change DVT/Cuộn");
      this.info.unitBag = this.info.unitHank * this.info.hankBag;
    },
    "info.hankBag": function() {
      console.log("change cuộn/Bịch");
      this.info.unitBag = this.info.unitHank * this.info.hankBag;
      this.info.hankSack = this.info.hankBag * this.info.bagSack;
    },
    "info.unitBag": function() {
      console.log("change DVT/Bich");
      this.info.unitSack = this.info.unitBag * this.info.bagSack;
    },
    "info.bagSack": function() {
      console.log("change Bao/Bịch");
      this.info.unitSack = this.info.unitBag * this.info.bagSack;
      this.info.hankSack = this.info.hankBag * this.info.bagSack;
    }
  }
};
</script>
